
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faUnlockAlt } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Form, Button, Container, InputGroup } from '@themesberg/react-bootstrap';

import { login } from '../../controller/api/auth'
import { useCookies } from 'react-cookie';
import { useHistory } from 'react-router-dom';
import { Routes } from '../../routes';
import { persistAdminSession } from '../../helper/adminSession';
import { toast } from 'react-toastify';

export default () => {

  const [, setCookie] = useCookies(['lottmekong']);
  const history = useHistory();

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const onEmailInput = ({target:{value}}) => setEmail(value)
  
  const onPasswordInput = ({target:{value}}) => setPassword(value)

  const handleSubmit = async (event) => {
    event.preventDefault()

    try {
      const token = await login(email, password)

      if (!token?.token) {
        toast.error('Đăng nhập thất bại')
        return
      }

      persistAdminSession(token)
      setCookie('lottmekong', token.token, { path: '/' });
      history.replace(Routes.Overview.path)
    } catch (error) {
      const message = error?.response?.data?.message || error?.message || 'Đăng nhập thất bại'
      toast.error(message)
    }
  }

  return (
    <main>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          <Row className="justify-content-center form-bg-image">
            <Col xs={12} className="d-flex align-items-center justify-content-center">
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className="text-center text-md-center mb-4 mt-md-0">
                  <h3 className="mb-0">Đăng nhập</h3>
                </div>
                <Form className="mt-4" onSubmit={handleSubmit}>
                  <Form.Group id="email" className="mb-4">
                    <Form.Label>Email</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faEnvelope} />
                      </InputGroup.Text>
                      <Form.Control autoFocus required type="email" placeholder="example@company.com" name="email" value={email} onChange={onEmailInput} />
                    </InputGroup>
                  </Form.Group>
                  <Form.Group>
                    <Form.Group id="password" className="mb-4">
                      <Form.Label>Mật khẩu</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faUnlockAlt} />
                        </InputGroup.Text>
                        <Form.Control required type="password" placeholder="Password" name="password" value={password} onChange={onPasswordInput} />
                      </InputGroup>
                    </Form.Group>
                  </Form.Group>
                  <Button variant="primary" type="submit" className="w-100">
                    Đăng nhập
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};
